import { PLAN_REF_ID_MAPPING } from "@/data/plans";

// Customer.io segment conditions can't match inside arrays, so array values are
// flattened to a comma string (e.g. "AFTERSHOOT_CULLING,AFTERSHOOT_EDITING").
const LIST_SEPARATOR = ",";

// Plan ids and their SKU nicknames always list in this order, whatever order
// the user clicked them in, so a condition only has to match one string.
const VALUE_ORDER: string[] = [
  PLAN_REF_ID_MAPPING.culling,
  PLAN_REF_ID_MAPPING.editing,
  PLAN_REF_ID_MAPPING.retouching,
  PLAN_REF_ID_MAPPING.all,
  "Select",
  "Edit",
  "Retouch",
  "Complete",
];

const isPrimitive = (value: unknown) =>
  typeof value === "string" ||
  typeof value === "number" ||
  typeof value === "boolean";

const rankOf = (value: unknown) => {
  const index = VALUE_ORDER.indexOf(String(value));
  return index === -1 ? VALUE_ORDER.length : index;
};

const toEventList = (values: unknown[]) =>
  [...values]
    .sort((a, b) => rankOf(a) - rankOf(b) || String(a).localeCompare(String(b)))
    .join(LIST_SEPARATOR);

/** Flattens array properties to ordered comma strings; other values pass through. */
export const formatCustomerIOEventProps = (
  properties: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(properties).map(([key, value]) => [
      key,
      Array.isArray(value) && value.every(isPrimitive)
        ? toEventList(value)
        : value,
    ]),
  );
